<template>
  <div>
    <div class="main">
      <div class="majorList">
        <h1 class="title">资源库精选专业</h1>
        <ul class="majorUL clearfix">
          <li class="majorLi" :key="index" v-for="(item, index) in majorArr">
            {{ item.name }}
          </li>
        </ul>
      </div>

      <div class="onLine clearfix">
        <div class="onLineLef left">
          <h1 class="title">金课在线</h1>
          <p class="linetext">
            由梧桐花教育平台推出，致力于为每一个有提升愿望的高校教师提供学习交流的平台，一键管理班级，让学生能够学到高校优质课程。
          </p>
          <ul class="clearfix iconul">
            <li
              class="iconli left"
              v-for="(item, index) in imageArr"
              :key="index"
            >
              <img class="icon" :src="item.img" alt />
              <span class="icontext">{{ item.name }}</span>
            </li>
          </ul>
          <button class="button">了解资源库</button>
        </div>
        <div class="onLineRight left">
          <img :src="imgUrl" alt />
        </div>
      </div>

      <div class="coursediv">
        <h1 class="title">在线学习</h1>
        <p class="coursetext">推荐优质线上课程,支持在线交流测试</p>
        <ul class="clearfix courseul">
          <!-- <li class="linecourseli left" :key="index" v-for="(item,index) in couseArr">
          <img class="cover" :src="imgUrl" alt />
          <p class="courseName">教学课程制作</p>
          <p class="teachName">张军教授</p>
        </li>-->
          <Item
            :key="index"
            v-for="(item, index) in couseArr"
            :item="item"
            :index="index"
          ></Item>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Item from '@/components/Item/index.vue'
export default {
  components: {
    Item,
  },
  data() {
    return {
      majorArr: [
        { name: '计算机专业一', id: 1 },
        { name: '计算机专业二', id: 2 },
      ],
      couseArr: [
        {
          name: '建立专业',
          // img: require('../../assets/img/banner.png'),
        },
        {
          name: '开设班级',
          // img: require('../../assets/img/banner.png'),
        },
        {
          name: '上传课程及资源',
          // img: require('../../assets/img/banner.png'),
        },
        {
          name: '组卷考试',
          // img: require('../../assets/img/banner.png'),
        },
        {
          name: '数据统计与分析',
          // img: require('../../assets/img/banner.png'),
        },
      ],
      // imgUrl: require('../../assets/img/banner.png'),
      imageArr: [
        {
          name: '建立专业',
          img: require('../../assets/img/setmajor.png'),
        },
        {
          name: '开设班级',
          img: require('../../assets/img/openClass.png'),
        },
        {
          name: '上传课程及资源',
          img: require('../../assets/img/upload.png'),
        },
        {
          name: '组卷考试',
          img: require('../../assets/img/exam.png'),
        },
        {
          name: '数据统计与分析',
          img: require('../../assets/img/datastatic.png'),
        },
        {
          name: '管理平台资源及用户',
          img: require('../../assets/img/plat.png'),
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.teachName {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-top: 11px;
  margin-left: 15px;
}
.courseName {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 30px;
  margin-left: 15px;
}
.cover {
  width: 228px;
  height: 130px;
}
.coursetext {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(47, 47, 57, 1);
  margin-bottom: 31px;
}
.coursediv {
  margin-bottom: 20px;
}
.onLineLef {
  width: 530px;
}
.iconul {
  width: 100%;
}
.icontext {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 25px;
  display: inline-block;
}
.iconli {
  height: 25px;
  margin-bottom: 20px;
  width: 175px;
}
.icon {
  width: 21px;
  height: 23px;
  vertical-align: middle;
  margin-right: 11px;
  display: inline-block;
}
.button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  color: #fff;
  width: 140px;
  height: 36px;
  background: linear-gradient(
    45deg,
    rgba(53, 180, 254, 1),
    rgba(15, 135, 254, 1)
  );
  border-radius: 18px;
}
.linetext {
  width: 523px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(48, 48, 58, 1);
  line-height: 26px;
  margin-bottom: 30px;
}
.title {
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: rgba(68, 68, 68, 1);
  margin-bottom: 30px;
}
.majorList {
  margin-bottom: 40px;
}
.majorList h1 {
  margin-top: 30px;
  font-size: 26px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: rgba(68, 68, 68, 1);
}
.majorLi {
  float: left;
  padding: 9px 20px;
  background: rgba(237, 237, 237, 1);
  border-radius: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(52, 52, 52, 1);
  margin-right: 10px;
}

.majorUL {
  margin-bottom: 20px;
  margin-top: 30px;
}

.onLineRight img {
  width: 400px;
  height: 300px;
  margin-left: 126px;
}
</style>